import '../../../../assets/css/request_details.css'
import './off_catalogue_request_details.css'
import React, { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles';
import Toolbar from '@mui/material/Toolbar';
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import Backdrop from '@mui/material/Backdrop';
import swal from 'sweetalert';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckIcon from '@mui/icons-material/Check';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import View_refuse_reason from '../view_refuse_reason/view_refuse_reason';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { Accordion } from 'react-bootstrap';
import EditIcon from '@mui/icons-material/Edit';
import Loading_animation_view from '../../../loading_animation_view/loading_animation_view';
import {
    get_applicant_request_details, service_change_off_catalogue_state_request,
    notify_initially_suppliers_with_articles, add_quote_to_orderRequest, service_change_order_state, add_delivery_file_to_orderRequest,
    check_new_request_for_validation
} from '../../../../services/purchase_service';
import { get_order_productsInfos, download_orderRequest_quote, check_weither_ispossible_to_proceed, download_order_file, download_delivery_file } from '../../../../services/for_allServices';
import Set_supplier from './set_suppliers/set_supplier';
import Set_refuse_reason from './set_refuse_reason/set_refuse_reason';
import Order_details from './order_details/order_details';
import Rating_modal from './rating_modal';
import Rating from '@mui/material/Rating';
import Validation_history from '../validation_history/validation_history';
import Stock_details_accordian from './verify_stock/stock_details';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import SetContract_for_order from './setContract_for_order/setContract_for_order';
import Edit_product_modal from './edit_product_modal/edit_product_modal';
import { getActiveProjects } from '../../../../services/project_service';
import { updatePurchaseRequest } from '../../../../services/purchase_service';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: 16,
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    input: {
        display: 'none',
    },
}));


function Request_detail({ title, details }) {

    const [isEditing, setIsEditing] = useState(false);
    const [projects, setProjects] = useState([]);
    const [formDetails, setFormDetails] = useState(details);


    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await getActiveProjects();
                if (response.data.success) {
                    setProjects(response.data.data);
                } else {
                    console.error("Erreur : ", response.data.message);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des projets :", error);
            }
        };

        fetchProjects();
    }, []);


    async function save_request_changes() {
        await updatePurchaseRequest(formDetails)
            .then(() => {
                swal("Succès", "Demande mise à jour avec succès", "success");
                setIsEditing(false); // désactive la modification
            })
            .catch((error) => {
                console.error(error);
                swal("Erreur", "Échec de l'enregistrement", "error");
            });

    }
    return (
        <div className="requester_details_container order_plus_details_container">
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <div className='accordion_header_content'> <span>{title}</span> </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className="order_form_details_container">
                            <div className="order_form_infos_container">
                                <div className='order_form_infos_title'> 1 - Infos personnel</div>
                                <Row className="mb-12">
                                    <Form.Group className="col-6">
                                        <label>Nom</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Nom *"
                                            value={formDetails.requester_lastName}
                                            onChange={(e) => setFormDetails({ ...formDetails, requester_lastName: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Prénom</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Prénom *"
                                            value={formDetails.requester_firstName}
                                            onChange={(e) => setFormDetails({ ...formDetails, requester_firstName: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Département</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Département *"
                                            value={formDetails.requester_departement}
                                            onChange={(e) => setFormDetails({ ...formDetails, requester_departement: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6"> </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Email</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="email"
                                            placeholder="Email *"
                                            value={formDetails.requester_email}
                                            onChange={(e) => setFormDetails({ ...formDetails, requester_email: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Numéro de téléphone</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Numéro de téléphone *"
                                            value={formDetails.requester_phoneNumber}
                                            onChange={(e) => setFormDetails({ ...formDetails, requester_phoneNumber: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                </Row>
                                <div className='order_form_infos_title'>2 - Infos de livraison</div>
                                <Row className="mb-12">
                                    <Form.Group className="col-6">
                                        <label>Pays</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Pays*"
                                            value={formDetails.delivery_country}
                                            onChange={(e) => setFormDetails({ ...formDetails, delivery_country: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Ville</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Ville *"
                                            value={formDetails.delivery_city}
                                            onChange={(e) => setFormDetails({ ...formDetails, delivery_city: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Adresse</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Adresse *"
                                            value={formDetails.delivery_address}
                                            onChange={(e) => setFormDetails({ ...formDetails, delivery_address: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Code postal</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Code postal *"
                                            value={formDetails.delivery_postCode}
                                            onChange={(e) => setFormDetails({ ...formDetails, delivery_postCode: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>

                                    <Form.Group className="col-6">
                                        <label>Date de livraison souhaitée</label>
                                        <Form.Control
                                            type="date"
                                            min={(new Date()).toISOString().split('T')[0]}
                                            placeholder="Date de livraison souhaitée *"
                                            value={formDetails.delivery_supposedDate.split(' ')[0]}
                                            onChange={(e) =>
                                                setFormDetails({
                                                    ...formDetails,
                                                    delivery_supposedDate: e.target.value
                                                })
                                            }
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                </Row>
                                <div className='order_form_infos_title'>3 - Autres informations</div>
                                <Row className="mb-12">
                                    <Form.Group className="col-sm-12">
                                        <label>Projet</label>
                                        {isEditing ? (
                                            // Mode édition : SELECT
                                            <Form.Control
                                                as="select"
                                                value={formDetails.project_code}
                                                onChange={(e) =>
                                                    setFormDetails({
                                                        ...formDetails,
                                                        project_code: e.target.value
                                                    })
                                                }
                                            >
                                                <option value="">Aucun projet (désassocier)</option>
                                                {projects.map((project) => (
                                                    <option key={project.project_code} value={project.project_code}>
                                                        {project.title}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        ) : (
                                            // Mode lecture seule : TEXTE
                                            <Form.Control
                                                type="text"
                                                value={formDetails.project_code}
                                                readOnly
                                            />
                                        )}
                                    </Form.Group>
                                    <Form.Group className="col-md-12">
                                        <label>Description de la demande</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            as="textarea"
                                            minRows={5}
                                            placeholder="Description de la demande *"
                                            value={formDetails.off_catalogue}
                                            onChange={(e) =>
                                                setFormDetails({
                                                    ...formDetails,
                                                    object: e.target.value
                                                })
                                            }
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-md-12">
                                        <label>Objet de la demande</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            as="textarea" rows="3"
                                            placeholder="Objet de la demande *"
                                            value={formDetails.object}
                                            onChange={(e) =>
                                                setFormDetails({
                                                    ...formDetails,
                                                    object: e.target.value
                                                })
                                            }
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                </Row>
                            </div>
                        </div>
                        <div className="proceed_button_container">
                            {isEditing ? (
                                <Button
                                    className="submit_but valide_but"
                                    onClick={save_request_changes}
                                >
                                    Enregistrer
                                </Button>
                            ) : (
                                <Button
                                    className="submit_but"
                                    onClick={() => setIsEditing(true)}
                                >
                                    Modifier
                                </Button>
                            )}
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    )
}

function state(request_state) {
    return (
        <>
            {
                request_state === null || request_state === "demander à être changée"
                    ? <Button variant="contained" className="status_waiting">{request_state ? request_state : 'En cours'}</Button>
                    : request_state === "refusée" || request_state === "refus de validation" || request_state === "annulée" || request_state === "refusée par le fournisseur" || request_state === "non retenue" || request_state === "non conforme"
                        ? <Button variant="contained" className="status_deny">{request_state}</Button>
                        : request_state === "sous réserve de validation"
                            ? <Button variant="contained" className="status_waiting">{request_state}</Button>
                            : <Button variant="contained" className="status_success">{request_state}</Button>
            }
        </>

    );
}

function request_state(request_state) {
    return (
        <>
            {
                request_state === null || request_state === "demander à être changée" || request_state?.includes("en cours") || request_state === "En cours de livraison (interne)"
                    ? <Button variant="contained" className="status_waiting">{request_state ? request_state : 'En cours'}</Button>
                    : request_state === "annulée" || request_state?.includes("refus") || request_state === "non conforme" || request_state === "Non conforme (interne)"
                        ? <Button variant="contained" className="status_deny">{request_state}</Button>
                        : <Button variant="contained" className="status_success">{request_state}</Button>
            }
        </>

    );
}


function validation_state(validation_state) {
    return (
        <>
            {
                validation_state === 0
                    ? <Button variant="contained" className="status_deny">{"refus de validation"}</Button>
                    : validation_state === null
                        ? <Button variant="contained" className="status_waiting">{"en cours de validation"}</Button>
                        : <Button variant="contained" className="status_success">{"validé"}</Button>
            }
        </>

    );
}

function View_request_order_validation({ request_order_validation }) {
    const [global_validation_state, setglobal_validation_state] = useState(null);
    const [view_validation_history, setview_validation_history] = useState(null);

    useEffect(() => {
        let validated = null;
        let comment = null;
        let tmp_validation_history = request_order_validation.sort((a, b) => (new Date(b.created_at) - new Date(a.created_at)));
        let users_id = [];
        for (let step of tmp_validation_history) {
            console.log("step", step);
            if (!users_id.includes(step.user) && step.validated == 1) users_id.push(step.user);
            if (step.validated == 0 && !users_id.includes(step.user)) {
                validated = 0;
                comment = step.comment;
                users_id.push(step.user);
                break;
            }
        }
        setglobal_validation_state({
            "validated": validated,
            "comment": comment
        })
    }, [])

    return (
        <>
            {
                global_validation_state != null
                    ? <div className='request_state_container'>
                        {validation_state(global_validation_state.validated)}
                        <>
                            {/*
                                <span
                                    className='view_reason_button'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setview_validation_history(request_order_validation)
                                    }}
                                >
                                    Historique
                                </span>
                            */}
                        </>
                    </div>
                    : <></>
            }
            {
                view_validation_history != null
                    ? <Validation_history view_validation_history={view_validation_history} setview_validation_history={setview_validation_history} />
                    : <></>
            }
        </>
    );
}


function Accordian_order_detail({ request_code, upload_delivery_file, details, supplier, id, upload_quote, download_quote, setSelected_suppliers, selected_suppliers, able_to_process_request,
    request_validation_processes, setRequest_validation_processes, setOpen_rating_modal, download_order_details_file, delivery_filepath }) {

    const [open_reason_modal, setOpen_reason_modal] = useState(null);
    const [view_validation_history, setview_validation_history] = useState(null);

    const [setContract, setSetContract] = useState(false);
    let purchase_service = JSON.parse(localStorage.getItem('user-info'));
    const [chosenSubmission, setchosenSubmission] = useState(null);

    const [request_order_validation, setrequest_order_validation] = useState(null);
    const [able_to_process_order, setable_to_process_order] = useState(null);

    useEffect(() => {
        console.log(request_validation_processes);
        get_request_order_validation(request_validation_processes, details.order_id);
        verify_request_order_validation(request_validation_processes, details.order_id);
    }, []);

    function openContractView(submission) {
        console.log("submission", submission);
        setSetContract(true);
        setchosenSubmission(submission);
    }
    function handleCloseSetContrat(submission) {
        setSetContract(false);
        setchosenSubmission(null);
    }

    function get_request_order_validation(validation_processes, order_id) {
        console.log("order_id", order_id);
        let order_validation_process = validation_processes.filter((proc) => proc.request_order_id == order_id);
        console.log(order_validation_process);
        setrequest_order_validation(order_validation_process);
    }

    function verify_request_order_validation(validation_processes, order_id) {
        let order_validation_process = validation_processes.filter((step) => step.request_order_id == order_id).sort((a, b) => (new Date(b.created_at) - new Date(a.created_at)));
        let able_to_proceed = true;
        let users_id = [];
        for (let step of order_validation_process) {
            if (!users_id.includes(step.user) && step.validated == 1) users_id.push(step.user);
            if (step.validated != 1 && !users_id.includes(step.user)) {
                able_to_proceed = false;
                users_id.push(step.user);
                break;
            }
        }
        console.log("validation process : ", order_validation_process, users_id, able_to_proceed);
        setable_to_process_order(able_to_proceed && able_to_process_request);
    }

    async function reverify_request_order_validation(order_id) {
        console.log(details);
        const formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('order_id', order_id);
        let validation_processes = await check_weither_ispossible_to_proceed(formData).then((response) => {
            console.log("check_weither_ispossible_to_proceed : ", response.data);
            setRequest_validation_processes(response.data);
            return response.data;
        }).catch((error) => {
            console.log(error.response);
        });
        let order_validation_process = validation_processes.filter((step) => step.request_order_id == order_id).sort((a, b) => (new Date(b.created_at) - new Date(a.created_at)));
        let able_to_proceed = true;
        let users_id = [];
        for (let step of order_validation_process) {
            if (!users_id.includes(step.user) && step.validated == 1) users_id.push(step.user);
            if (step.validated != 1 && !users_id.includes(step.user)) {
                able_to_proceed = false;
                users_id.push(step.user);
                break;
            }
        }
        get_request_order_validation(validation_processes, order_id);
        setable_to_process_order(able_to_proceed && able_to_process_request);
        //console.log("validation process : ", order_validation_process, users_id, able_to_proceed);
        return able_to_proceed;
    }


    return (
        <div>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <div className='order_accordion_header'>
                            <div className='accordion_header_content'>
                                <span>{"Commande n°" + (id + 1) + " / "}</span>
                                <span className="supplier_infos">{supplier.parentCompany + " -- " + supplier.fullName}</span>
                                <div class="rating_final_score_container" onClick={(e) => { e.stopPropagation(); setOpen_rating_modal({ "request_code": request_code, "id_supplier": supplier.id, "order_id": supplier.order_id, "id": id, "ratings": supplier.ratings }) }}>
                                    <Rating name="customized-10" value={(supplier.rating_score ? (supplier.rating_score / 5) : 0)} precision={0.1} max={1} readOnly />
                                    <span class="rating_final_score">{supplier.rating_score ? supplier.rating_score : 0}/5</span>
                                </div>
                                <>
                                    {<span
                                        className='view_reason_button'
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setview_validation_history(request_order_validation)
                                        }}
                                    >(Historique)</span>
                                    }
                                </>
                            </div>
                            <div className='accordion_header_actions'>
                                <div style={{ display: 'flex' }} >
                                    {
                                        ["conforme en attente de livraison",
                                            "conforme",
                                            "En cours de livraison (interne)",
                                            "reçu"
                                        ].includes(supplier.order_state) ?
                                            <Fab style={{ marginRight: '8px' }} size="small" color="info" onClick={(e) => { e.stopPropagation(); openContractView(supplier.order_id) }}>
                                                <ContentPasteIcon className="my_icon" />
                                            </Fab>
                                            : <></>
                                    }
                                    <Tooltip title="Télecharger le devis" placement="bottom" >
                                        <span style={{ marginRight: '8px' }} onClick={(e) => download_quote(e, supplier)} >
                                            <Fab size="small" style={{ backgroundColor: '#efefef', color: 'black' }} className={supplier.order_state != null ? "round_button" : "round_button disabled_button"} >
                                                <GetAppRoundedIcon className="my_icon" />
                                            </Fab>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title={supplier.delivery_file == null
                                        ? "Télécharger le bon de commande"
                                        : "Télécharger les fichiers"} placement="bottom" >
                                        <span style={{ marginLeft: '6px' }}>
                                            <Fab size="small" onClick={(e) => download_order_details_file(e, request_code, supplier)} color='default' style={{ backgroundColor: '#efefef' }} className={supplier.order_file != null ? "round_button" : "round_button disabled_button"} >
                                                <DownloadOutlinedIcon className="my_icon" />
                                            </Fab>
                                        </span>
                                    </Tooltip>
                                    {supplier.delivery_file == null ? (
                                        <Tooltip title="Importer le bon de livraison" placement="bottom">
                                            <span style={{ marginLeft: '10px' }}>
                                                <label htmlFor={'uploadContract' + supplier.id} style={{ marginRight: '8px', cursor: 'pointer' }}>
                                                    <input
                                                        accept="application/*"
                                                        id={'uploadContract' + supplier.id}
                                                        name={'uploadContract' + supplier.id}
                                                        type="file"
                                                        multiple
                                                        style={{ display: 'none' }}
                                                        onChange={(e) => upload_delivery_file(e.target.files[0], supplier, supplier.order_id)}
                                                    />
                                                    <Fab size="small" variant="contained" component="span">
                                                        <CloudUploadIcon className="my_icon" />
                                                    </Fab>
                                                </label>
                                            </span>
                                        </Tooltip>
                                    ) : null}
                                </div>
                                <>
                                    {
                                        able_to_process_order == true || ["annulée"].includes(supplier.order_state)
                                            ? <>{/*
                                                <div className='action_button_container' >
                                                    {
                                                        supplier.order_state !== "annulée" && supplier.order_state !== "conforme" && (supplier.order_state !== null && supplier.order_state !== "demander à être changée") && supplier.order_state !== "sous réserve de validation"
                                                            ? <>
                                                                {
                                                                    supplier.order_state !== "bien reçu"
                                                                        ? <Tooltip title="la commande est reçue" placement="top" >
                                                                            <span style={{ color: 'rgb(228, 88, 32)' }}
                                                                                className={supplier.order_state === "en cours de livraison" ? "checkIcon" : "checkIcon disabled_button"}>
                                                                                <DoneIcon className="my_icon" style={{ cursor: 'pointer' }} onClick={(e) => well_received(e, supplier.id, request_code, id)} />
                                                                            </span>
                                                                        </Tooltip>
                                                                        : <>
                                                                            <Tooltip title="Commande non conforme" placement="top" >
                                                                                <span style={{ color: '#e92a44', marginRight: '6px' }} onClick={(e) => order_no_conforme(e, supplier.id, request_code, id)}>
                                                                                    <RemoveDoneIcon style={{ cursor: 'pointer' }} className="my_icon closeSharpIcon" />
                                                                                </span>
                                                                            </Tooltip>
                                                                            <Tooltip title="Commande conforme" placement="top" >
                                                                                <span style={{ color: '#18ac67' }} onClick={(e) => order_conforme(e, supplier.id, request_code, id)} >
                                                                                    <DoneAllIcon style={{ cursor: 'pointer' }} className="my_icon checkIcon" />
                                                                                </span>
                                                                            </Tooltip>
                                                                        </>
                                                                }
                                                            </>
                                                            : <></>
                                                    }
                                                </div>
                                                */}
                                                <div className='request_state_container'>
                                                    {state(supplier.order_state)}
                                                    <>
                                                        {
                                                            supplier.order_state === "sous réserve de validation" || supplier.order_state === "refusée" || supplier.order_state === "non conforme"
                                                                || supplier.order_state === "refus de validation" || supplier.order_state === "annulée" || supplier.order_state === "refusée par le fournisseur"
                                                                ? <span className='view_reason_button' onClick={(e) => { e.stopPropagation(); setOpen_reason_modal(supplier.service_refuse_reason && supplier.order_state !== "refusée par le fournisseur" && supplier.order_state !== "refusée" && supplier.order_state !== "sous réserve de validation" ? supplier.service_refuse_reason : supplier.refuse_reason) }}>Motif</span>
                                                                : <></>
                                                        }
                                                    </>
                                                </div>
                                            </>
                                            : <>{request_order_validation != null ? <View_request_order_validation request_order_validation={request_order_validation} /> : <></>}</>
                                    }
                                </>
                            </div>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body className={able_to_process_request ? "" : "disabled_button"}>
                        <Order_details selected_products_details={supplier} request_code={request_code} id_supplier={supplier.id} selected_suppliers={selected_suppliers}
                            setSelected_suppliers={setSelected_suppliers} order_key={id} order_number={id + 1} able_to_process_order={able_to_process_order} reverify_request_order_validation={reverify_request_order_validation} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            {
                open_reason_modal !== null
                    ? <View_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal} />
                    : <></>
            }
            {
                view_validation_history != null
                    ? <Validation_history view_validation_history={view_validation_history} setview_validation_history={setview_validation_history} />
                    : <></>
            }
            {chosenSubmission != null && setContract == true
                ? <SetContract_for_order setContract={setContract} handleCloseSetContrat={() => handleCloseSetContrat(supplier.order_id)} purchase_service={purchase_service} chosenSubmission={supplier.order_id} />
                : <></>}
        </div>
    )
}

function Order_detail({ request_code, supplier, id, upload_quote, download_quote, accept_supplier_offer, refuse_supplier_offer, setOpen_rating_modal, download_order_details_file }) {
    const classes = useStyles();
    const [open_reason_modal, setOpen_reason_modal] = useState(null);

    return (
        <div className="accordion supplier_accordion">
            <div eventKey="0" className='accordion-button'>
                <div className='accordion_header_content'>
                    <span>{"Consultation n°" + (id + 1) + " / "}</span>
                    <span className="supplier_infos">{supplier.parentCompany + " -- " + supplier.fullName}</span>
                    <div class="rating_final_score_container" onClick={(e) => { e.stopPropagation(); setOpen_rating_modal({ "request_code": request_code, "id_supplier": supplier.id, "order_id": supplier.order_id, "id": id, "ratings": supplier.ratings }) }}>
                        <Rating name="customized-10" value={(supplier.rating_score ? (supplier.rating_score / 5) : 0)} precision={0.1} max={1} readOnly />
                        <span class="rating_final_score">{supplier.rating_score ? supplier.rating_score : 0}/5</span>
                    </div>
                </div>
                <div className='accordion_header_actions'>
                    <div style={{ display: 'flex' }} >
                        <Tooltip title="Importer le devis" placement="bottom" >
                            <span style={{ marginRight: '8px' }}>
                                <label htmlFor={'uploadContract' + supplier.id} style={{ margin: '0' }}>
                                    <Fab size="small" variant="contained" component='span'>
                                        <CloudUploadIcon className="my_icon" />
                                    </Fab>
                                    <input accept='application/*' className={classes.input} name={'uploadContract' + supplier.id}
                                        id={'uploadContract' + supplier.id} multiple type='file' onChange={(e) => upload_quote(e.target.files[0], supplier.id, id, supplier.order_id)} />
                                </label>
                            </span>
                        </Tooltip>
                        <Tooltip title="Télecharger le devis" placement="bottom" >
                            <span style={{ marginRight: '8px' }} onClick={(e) => download_quote(e, supplier)} >
                                <Fab size="small" color='default' className={supplier.order_state != null ? "" : "disabled_button"} >
                                    <GetAppRoundedIcon className="my_icon" />
                                </Fab>
                            </span>
                        </Tooltip>
                        <>
                            {
                                supplier.order_state !== "devis ajouté" && supplier.order_state !== "refusée" && supplier.order_state !== "non retenue"
                                    ? <></>
                                    : <>
                                        <Tooltip title="Refuser l'offre" placement="top" >
                                            <span style={{ color: '#e92a44', marginRight: '3px' }} onClick={() => refuse_supplier_offer(supplier, id)}>
                                                <CloseSharpIcon style={{ cursor: 'pointer' }} className="my_icon closeSharpIcon" />
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="Retenir l'offre" placement="top" >
                                            <span style={{ color: '#18ac67', marginRight: '9px' }} onClick={() => accept_supplier_offer(supplier, id)} >
                                                <CheckIcon style={{ cursor: 'pointer' }} className="my_icon checkIcon" />
                                            </span>
                                        </Tooltip>
                                    </>
                            }
                        </>
                    </div>
                    <div className='request_state_container'>
                        {state(supplier.order_state)}
                        <>
                            {
                                supplier.order_state === "sous réserve de validation" || supplier.order_state === "refusée" || supplier.order_state === "refus de validation" || supplier.order_state === "annulée" || supplier.order_state === "non retenue"
                                    ? <span className='view_reason_button' onClick={(e) => { e.stopPropagation(); setOpen_reason_modal(supplier.service_refuse_reason ? supplier.service_refuse_reason : supplier.refuse_reason) }}>Motif</span>
                                    : <></>
                            }
                        </>
                    </div>
                </div>
            </div>
            {
                open_reason_modal !== null
                    ? <View_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal} />
                    : <></>
            }
        </div>
    )
}


function Currently_added_suppliers({ supplier, id, removeSupplier, selected_suppliers_length }) {
    const classes = useStyles();
    const [open_reason_modal, setOpen_reason_modal] = useState(null);

    return (
        <div className="accordion supplier_accordion">
            <div eventKey="0" className='accordion-button'>
                <div className='accordion_header_content'>
                    <span>{"Consultation n°" + (selected_suppliers_length + id + 1) + " / "}</span>
                    <span className='supplier_infos'>{supplier.parentCompany + " -- " + supplier.fullName}</span>
                </div>
                <div className='accordion_header_actions'>
                    <RemoveIcon className="my_icon" onClick={() => removeSupplier(id)} />
                </div>
            </div>
            {
                open_reason_modal !== null
                    ? <View_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal} />
                    : <></>
            }
        </div>
    )
}

function Off_catalogue_request_details({ request_code, setRequest_code, request_details, setRequest_details }) {

    const [suppliers, setSuppliers] = useState([]);
    const [selected_suppliers, setSelected_suppliers] = useState(null);

    const [details, setDetails] = useState(null);
    const [wait_submitting, setWait_submitting] = useState(false);
    const [delivery_filepath, setDelivery_filepath] = useState(null);

    const [order_count, setOrder_count] = useState(1);
    const [open_rating_modal, setOpen_rating_modal] = useState(null);

    const [open_supplier_modal, setOpen_supplier_modal] = useState(false);
    const [open_reason_modal, setOpen_reason_modal] = useState(null);

    const [request_validation_processes, setRequest_validation_processes] = useState([]);
    const [open_edit_product_modal, setOpen_edit_product_modal] = useState(null);
    const [article, setArticle] = useState(null);
    const [articleIndex, setArticleIndex] = useState(null);

    const [able_to_process_request, setAble_to_process_request] = useState(false);
    const [view_validation_history, setview_validation_history] = useState(null);

    const [notify, setNotify] = useState(false);
    const classes = useStyles();



    useEffect(() => {
        setDetails(null);
        async function get_orders_products(tmp_selected_suppliers, request_code) {
            var tmp_array = [];
            for (let id_supplier in tmp_selected_suppliers) {
                let tmp_products_bysupplier = {};
                let products = JSON.parse(tmp_selected_suppliers[id_supplier].products)["products"];
                if (products) {
                    let selected_products_tmp_array = [];
                    products.map((selected_product) => {
                        selected_products_tmp_array.push(selected_product.product_code);
                    })
                    let formData = new FormData();
                    formData.append('products_codes', JSON.stringify(selected_products_tmp_array));
                    formData.append('request_code', request_code);
                    formData.append('id_supplier', tmp_selected_suppliers[id_supplier].id);
                    await get_order_productsInfos(formData).then((response) => {
                        let selected_products_details_tmp_array = [];
                        let data = response.data;
                        //console.log(data);
                        for (const id_supplier_name in data) {
                            data[id_supplier_name].products.map((element, id) => {
                                products.map((selected_product, id) => {
                                    if (selected_product.product_code === element.product_code) {
                                        element.product_amount = element.product_amount ? element.product_amount : selected_product.product_amount;
                                    }
                                })
                                selected_products_details_tmp_array.push(element);
                            });
                            tmp_products_bysupplier = { ...tmp_selected_suppliers[id_supplier], ...data[id_supplier_name] };
                            tmp_products_bysupplier["replaced_by"] = response.data[id_supplier_name].replaced_by ? response.data[id_supplier_name].replaced_by : "";
                            tmp_products_bysupplier["order_id"] = response.data[id_supplier_name].order_id;
                            tmp_products_bysupplier["order_number"] = response.data[id_supplier_name].order_number;
                            tmp_products_bysupplier["order_state"] = response.data[id_supplier_name].order_state;
                            tmp_products_bysupplier["service_accord"] = response.data[id_supplier_name].service_accord;
                            tmp_products_bysupplier["products"] = selected_products_details_tmp_array;
                        }
                    }).catch((error) => {
                        //console.log(error.response);
                    });
                } else {
                    tmp_products_bysupplier = tmp_selected_suppliers[id_supplier];
                }
                tmp_array.push(tmp_products_bysupplier);
            }
            setSelected_suppliers(tmp_array);
        }

        async function load_data() {
            const formData = new FormData();
            formData.append('request_code', request_code);

            await check_weither_ispossible_to_proceed(formData).then((response) => {
                console.log("check_weither_ispossible_to_proceed : ", response.data);
                setRequest_validation_processes(response.data);
            }).catch((error) => {
                console.log(error.response);
            })

            await get_applicant_request_details(formData).then(async (response) => {
                const tmp_data = {
                    ...request_details,
                    ...response.data
                };
                console.log("tmp_data", tmp_data);
                await setAble_to_process_request(tmp_data.request_state !== null && (!tmp_data.request_state?.includes("refus") && !tmp_data.request_state?.includes("en cours de validation") && !tmp_data.request_state?.includes("annul") && (tmp_data.id_validation == null || tmp_data.validated == 1)));
                setDetails(tmp_data);
                get_orders_products(response.data.selected_suppliers, request_code);
            }).catch((error) => {
                //console.log(error.response);
            })

        }

        load_data();

    }, [notify]);


    function get_request_validation_hist(validation_processes) {
        let order_validation_process = validation_processes.filter((proc) => proc.request_order_id == 0);
        return order_validation_process;
    }

    function accept_to_treateOrder(request_code) {
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setWait_submitting(true);
                    let formData = new FormData();
                    formData.append('request_code', request_code);
                    formData.append('state', "en cours de traitement");
                    service_change_off_catalogue_state_request(formData).then((response) => {
                        //console.log(response.data);
                        setWait_submitting(false);
                        setDetails({
                            ...details,
                            request_state: "en cours de traitement"
                        });
                        setAble_to_process_request(true);
                        //console.log(tmp);
                        swal("votre réponse a été enregistrée avec succès !", {
                            icon: "success",
                        });
                    }).catch((error => {
                        //console.log(error.response);
                        setWait_submitting(false);
                    }))
                }
            })
    }

    function refuse_to_treateOrder(request_code) {
        let formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('state', "refus de traitement");
        setOpen_reason_modal(formData);
    }

    function notify_suppliers() {
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setWait_submitting(true);
                    let formData = new FormData();
                    formData.append('request_code', request_code);
                    formData.append('suppliers', JSON.stringify(suppliers));
                    formData.append('articles', details.products);
                    notify_initially_suppliers_with_articles(formData).then((response) => {
                        setWait_submitting(false);
                        //console.log(response.data);
                        setSuppliers([]);
                        setNotify(!notify);
                        swal("votre réponse a été enregistrée avec succès, et les fournisseurs seront informés !", {
                            icon: "success",
                        });
                    }).catch((error) => {
                        setWait_submitting(false);
                        //console.log(error);
                    })
                }
            });
    }

    function upload_quote(file, id_supplier, id, order_id) {
        console.log("!!", selected_suppliers);
        setWait_submitting(true);
        let formData = new FormData();
        //console.log(id_supplier);
        formData.append('request_code', request_code);
        formData.append('id_supplier', id_supplier);
        formData.append('quote_file', file);
        formData.append('order_id', order_id);
        add_quote_to_orderRequest(formData).then((response) => {
            setWait_submitting(false);
            let tmp_array = [...selected_suppliers];

            tmp_array[id].order_state = "devis ajouté";
            setSelected_suppliers(tmp_array);
        }).catch((error) => {
            setWait_submitting(false);
            //console.log(error.response);
        })
    }

    function accept_supplier_offer(order_infos, id) {
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setWait_submitting(true);
                    let formData = new FormData();
                    //console.log(id_supplier);
                    formData.append('request_code', request_code);
                    formData.append('id_supplier', order_infos.id);
                    formData.append('order_id', order_infos.order_id);
                    formData.append('state', "retenue");
                    service_change_order_state(formData).then((response) => {
                        setWait_submitting(false);
                        let tmp_array = [...selected_suppliers];
                        tmp_array[id].order_state = "retenue";
                        setSelected_suppliers(tmp_array);
                        swal("votre réponse a été enregistrée avec succès !", {
                            icon: "success",
                        });
                    }).catch((error) => {
                        setWait_submitting(false);
                        //console.log(error.response);
                    })
                }
            });
    }

    function refuse_supplier_offer(order_infos, id) {
        console.log(order_infos);
        let formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('id_supplier', order_infos.id);
        formData.append('order_id', order_infos.order_id);
        formData.append('state', "non retenue");
        formData.append('id', id);
        setOpen_reason_modal(formData);
    }

    function download_quote(e, order_infos) {
        console.log(order_infos);
        e.stopPropagation();
        let formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('order_id', order_infos.order_id);
        download_orderRequest_quote(formData).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            let file_extension = '';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.includes('filename')) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    file_extension = matches[1].replace(/['"]/g, '').split(".")[1];
                }
            }
            fileLink.setAttribute('download', request_code[0] + request_code[1] + "_" + order_infos.order_id + "_devis." + file_extension);
            document.body.appendChild(fileLink);
            fileLink.click();
        }).catch(err => {
            //console.log(err.response);
        });
    }

    function download_order_details_file(e, request_code, order_infos) {
        e.stopPropagation();
        let request_code_tmp_array = request_code.split(' - ');
        const formData = new FormData();
        formData.append('order_id', order_infos.order_id);
        formData.append('request_code', request_code);
        download_order_file(formData).then((response) => {
            const blob = new Blob([response.data]);
            const fileURL = window.URL.createObjectURL(blob);
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;

            let file_extension = getFileExtensionFromDisposition(response.headers['content-disposition']);
            fileLink.setAttribute(
                'download',
                `${request_code_tmp_array[0]}_${request_code_tmp_array[1]}_${order_infos.order_id}.${file_extension}`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            window.URL.revokeObjectURL(fileURL); // Clean up
        }).catch((error) => {
            console.log(error.response);
        });

        // Delivery file
        download_delivery_file(formData).then((response) => {
            const blob = new Blob([response.data]);
            const fileURL = window.URL.createObjectURL(blob);
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;

            let file_extension = getFileExtensionFromDisposition(response.headers['content-disposition']);
            fileLink.setAttribute(
                'download',
                `${request_code_tmp_array[0]}_${request_code_tmp_array[1]}_${order_infos.order_id}_delivery.${file_extension}`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            window.URL.revokeObjectURL(fileURL); // Clean up
        }).catch((error) => {
            console.log(error.response);
        })
    }

    // Utility to extract file extension from Content-Disposition
    function getFileExtensionFromDisposition(disposition) {
        if (disposition && disposition.includes('filename')) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                return matches[1].replace(/['"]/g, '').split(".").pop();
            }
        }
        return 'pdf'; // default fallback
    }

    function removeSupplier(id) {
        let tmp_array = [...suppliers];
        tmp_array.splice(id, 1);
        setSuppliers(tmp_array);
    }

    function set_supplier_rating_score_result(id, ratings, rating_score) {
        let tmp_array = [...selected_suppliers];
        tmp_array[id].rating_score = rating_score;
        tmp_array[id].ratings = ratings;
        setSelected_suppliers(tmp_array);
    }

    function well_received(e, id_supplier, request_code, id) {
        e.stopPropagation();
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setWait_submitting(true);
                    let formData = new FormData();
                    formData.append('id_supplier', id_supplier);
                    formData.append('request_code', request_code);
                    formData.append('state', "bien reçu");
                    service_change_order_state(formData).then((response) => {
                        //console.log(response.data);
                        const tmp_order_state = response.data.order_state;
                        let tmp_array = [...selected_suppliers];
                        tmp_array[id].order_state = tmp_order_state;
                        setSelected_suppliers(tmp_array);
                        setWait_submitting(false);
                        swal("votre réponse a été enregistrée avec succès et le service sera bientôt notifié !", {
                            icon: "success",
                        });
                    }).catch((error) => {
                        //console.log(error.response);
                        setWait_submitting(false);
                    })
                }
            });
    }


    function order_conforme(e, id_supplier, request_code, id) {
        e.stopPropagation();
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setWait_submitting(true);
                    let formData = new FormData();
                    formData.append('id_supplier', id_supplier);
                    formData.append('request_code', request_code);
                    formData.append('state', "conforme");
                    service_change_order_state(formData).then((response) => {
                        //console.log(response.data);
                        const tmp_order_state = response.data.order_state;
                        let tmp_array = [...selected_suppliers];
                        tmp_array[id].order_state = tmp_order_state;
                        setSelected_suppliers(tmp_array);
                        setWait_submitting(false);
                        swal("votre réponse a été enregistrée avec succès et le service sera bientôt notifié !", {
                            icon: "success",
                        });
                    }).catch((error) => {
                        //console.log(error.response);
                        setWait_submitting(false);
                    })
                }
            });
    }


    function order_no_conforme(e, id_supplier, request_code, id) {
        e.stopPropagation();
        let formData = new FormData();
        formData.append('id_supplier', id_supplier);
        formData.append('request_code', request_code);
        formData.append('state', "non conforme");
        formData.append('id', id);
        setOpen_reason_modal(formData);
    }

    const handleDataLoaded = () => {
        setWait_submitting(false);
    };
    function upload_delivery_file(file, order_infos) {
        setWait_submitting(true);
        let formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('order_id', order_infos.order_id);
        formData.append('delivery_file', file);

        add_delivery_file_to_orderRequest(formData).then((response) => {
            setWait_submitting(false);
            console.log("**", response.data);
            setDelivery_filepath(response.data.delivery_file_path);

            swal("Fichier de livraison importé avec succès !", {
                icon: "success",
                buttons: true,
            });

        }).catch((error) => {
            setWait_submitting(false);
            swal("Une erreur est survenue lors de l'import du fichier.", {
                icon: "error",
                buttons: true,
            });
        });
    }

    async function send_new_request_for_validation(request_code) {
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then(async (willDelete) => {
                if (willDelete) {
                    setWait_submitting(true);
                    let formData = new FormData();
                    formData.append("request_code", request_code);
                    await check_new_request_for_validation(formData).then((response) => {
                        console.log(response.data);
                        let tmp_details = { ...details };
                        tmp_details.request_state = "en cours de validation";
                        setDetails(tmp_details);
                        swal("votre réponse a été enregistrée avec succès !", {
                            icon: "success",
                        });
                    }).catch((error) => {
                        console.log(error.response);
                        swal("Personne n'est prévu pour la validation !", {
                            icon: "warning",
                        });
                    })
                    setWait_submitting(false);
                }
            })
    }

    async function refresh_request_articles(request_articles) {
        setDetails({
            ...details,
            products: request_articles
        });
    }

    return (
        <Dialog disableEnforceFocus fullScreen open={request_code ? true : false} onClose={() => { setRequest_code(null); setRequest_details(null) }} className="my_full_dialog contract_full_dialog" >
            <AppBar className={classes.appBar}  >
                <Toolbar style={{ backgroundColor: '#343a40' }} >
                    <div className="page_title">
                        <IconButton edge="start" color="inherit" onClick={() => { setRequest_code(null); setRequest_details(null) }} aria-label="close" >
                            <CloseIcon className="my_icon" />
                        </IconButton>
                        <span> Details de demande : {request_code} </span>
                        <>
                            {details !== null
                                ? <><div className='request_state_container'>
                                    <>{request_state(details.request_state)}</>
                                    {
                                        details.request_state === "demander à être changée" || details.request_state === "refusée"
                                            || details.request_state === "annulée" || details.request_state?.includes("refus")
                                            ? <span className='view_reason_button' onClick={() => setOpen_reason_modal(details.service_refuse_reason
                                                ? details.service_refuse_reason
                                                : details.requester_refuse_reason ?? details.comment)}>
                                                Motif
                                            </span>
                                            : <></>
                                    }
                                </div>
                                    {<span
                                        className='view_reason_button' style={{ margin: "0", marginLeft: "8px" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setview_validation_history(get_request_validation_hist(request_validation_processes))
                                        }}
                                    >(Historique)</span>
                                    }
                                </>
                                : <></>
                            }
                        </>
                    </div>
                    {
                        details !== null && !details.request_state?.includes("annulée") && (details.request_state == "en cours de traitement" || !able_to_process_request)
                            ? <div className="request_order_toolbar_right">
                                <>{
                                    (!able_to_process_request && !details.request_state?.includes("en cours de validation")) ? <Tooltip title="Refuser de la traiter" placement="bottom" >
                                        <span>
                                            <Button className={!wait_submitting ? "submit_but notify_requester_button cancel_but" : "submit_but notify_requester_button cancel_but disabled_button"}
                                                onClick={() => refuse_to_treateOrder(request_code)}>
                                                Refuser
                                            </Button>
                                        </span>
                                    </Tooltip>
                                        : <></>
                                }</>
                                <>{
                                    details.validated!=1 && (details.request_state == "en cours de traitement" || details.request_state === null || details.request_state?.includes("refus") || !able_to_process_request) ? <Tooltip title="Envoyer pour la validation du DSI" placement="bottom" >
                                        <span>
                                            <Button className={!wait_submitting ? "submit_but notify_requester_button" : "submit_but notify_requester_button disabled_button"}
                                                onClick={() => send_new_request_for_validation(request_code)}>
                                                Envoyer pour la validation du DSI
                                            </Button>
                                        </span>
                                    </Tooltip> : <></>
                                }</>
                                <>{
                                    (!able_to_process_request && !details.request_state?.includes("en cours de validation")) ? <Tooltip title="Accepter de la traiter" placement="bottom" >
                                        <span>
                                            <Button className={!wait_submitting ? "submit_but notify_requester_button valide_but" : "submit_but notify_requester_button valide_but disabled_button"}
                                                onClick={() => accept_to_treateOrder(request_code)}>
                                                Accepter
                                            </Button>
                                        </span>
                                    </Tooltip>
                                        : <></>
                                }</>
                            </div>
                            : <></>
                    }
                </Toolbar>
            </AppBar>

            {
                details !== null && selected_suppliers != null
                    ? <div className="off_catalogue_requestDetails_container request_details_container">
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginBottom: '7px' }}>
                            <div>
                                <span>
                                    <Button onClick={notify_suppliers} className={suppliers.length !== 0 && !wait_submitting ? "submit_but notify_requester_button" : "submit_but notify_requester_button disabled_button"}>
                                        Notifier les fournisseurs
                                    </Button>
                                </span>
                            </div>
                            <div className="add_icon_container">
                                <Tooltip title="Ajouter les fournisseurs" placement="bottom" >
                                    <span className={!able_to_process_request ? "disabled_button" : ""} onClick={() => setOpen_supplier_modal(true)}>
                                        <AddIcon className="my_icon" />
                                    </span>
                                </Tooltip>
                            </div>
                        </div>
                        <Request_detail
                            title="Détails"
                            details={details} />

                        <Stock_details_accordian
                            onDataLoaded={handleDataLoaded}
                            request_code={request_code}
                            setWait_submitting={setWait_submitting}
                            request_details={details}
                            request_orders={details.products}
                            able_to_process_request={able_to_process_request}
                        />
                        <>
                            {
                                selected_suppliers.map((supplier, id) => (
                                    supplier.order_state === null || supplier.order_state === "refusée" || supplier.order_state === "devis ajouté" || supplier.order_state === "non retenue"
                                        ? <Order_detail request_code={request_code} supplier={supplier} id={id} key={"supplierid" + id} upload_quote={upload_quote} download_quote={download_quote} download_order_details_file={download_order_details_file}
                                            accept_supplier_offer={accept_supplier_offer} refuse_supplier_offer={refuse_supplier_offer} setOpen_rating_modal={setOpen_rating_modal} />
                                        : <Accordian_order_detail supplier={supplier} details={supplier} id={id} key={"supplierid" + id} download_quote={download_quote} download_order_details_file={download_order_details_file}
                                            request_code={request_code} setSelected_suppliers={setSelected_suppliers} selected_suppliers={selected_suppliers}
                                            delivery_filepath={delivery_filepath}
                                            able_to_process_request={able_to_process_request}
                                            upload_delivery_file={upload_delivery_file}
                                            request_validation_processes={request_validation_processes} setRequest_validation_processes={setRequest_validation_processes}
                                            well_received={well_received} order_conforme={order_conforme} order_no_conforme={order_no_conforme} setOpen_rating_modal={setOpen_rating_modal} />
                                ))
                            }
                        </>


                        <>
                            {
                                suppliers.map((supplier, id) => (
                                    <Currently_added_suppliers supplier={supplier} id={id} key={"id-" + id} selected_suppliers_length={selected_suppliers.length} removeSupplier={removeSupplier} />
                                ))
                            }
                        </>


                        <>
                            <div className="articles_container">
                                {
                                    JSON.parse(details.products).articles.map((article, id) => (
                                        <div className='articles_view_container' key={"articles" + id}>
                                            <div className="article_view_header_container">
                                                <span>Article n°{id + 1}</span>
                                                <div>
                                                    <Tooltip title="Modifier" className={able_to_process_request ? "" : "disabled_button"}>
                                                        <Fab className="add_new_object_fab add_new_object_fab_big"  >
                                                            <EditIcon className="my_icon" onClick={() => { setOpen_edit_product_modal(true); setArticle(article); setArticleIndex(id); }} />
                                                        </Fab>
                                                    </Tooltip>
                                                </div>

                                            </div>
                                            <div>{article}</div>

                                        </div>
                                    ))
                                }
                                {
                                    open_edit_product_modal !== null
                                        ? <Edit_product_modal open_edit_product_modal={open_edit_product_modal} request_code={request_code} refresh_request_articles={refresh_request_articles}
                                            setOpen_edit_product_modal={setOpen_edit_product_modal} article={article} setArticle={setArticle} articles={JSON.parse(details.products).articles} articleIndex={articleIndex} />
                                        : <></>
                                }
                            </div>
                        </>

                    </div>
                    : <Loading_animation_view />
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={wait_submitting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {
                open_supplier_modal !== false
                    ? <Set_supplier open_supplier_modal={open_supplier_modal} setOpen_supplier_modal={setOpen_supplier_modal}
                        existent_suppliers={suppliers} selected_suppliers={selected_suppliers} setExistent_suppliers={setSuppliers} />
                    : <></>
            }

            {
                open_reason_modal != null && (open_reason_modal instanceof FormData)
                    ? <Set_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal}
                        details={details} setDetails={setDetails} selected_suppliers={selected_suppliers} setSelected_suppliers={setSelected_suppliers} />
                    : <></>
            }

            {
                open_reason_modal !== null && !(open_reason_modal instanceof FormData)
                    ? <View_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal} />
                    : <></>
            }

            {
                open_rating_modal != null
                    ? <Rating_modal open_rating_modal={open_rating_modal} setOpen_rating_modal={setOpen_rating_modal} set_supplier_rating_score_result={set_supplier_rating_score_result} />
                    : <></>
            }

            {
                view_validation_history != null
                    ? <Validation_history view_validation_history={view_validation_history} setview_validation_history={setview_validation_history} />
                    : <></>
            }

        </Dialog >
    )
}

export default Off_catalogue_request_details;
